// List of all columns for use in Select components
export const ALL_COLUMNS = [
  { value: 'endDate', label: 'Week Ending' },
  { value: 'status', label: 'Status' },
  { value: 'lastName', label: 'Last Name' },
  { value: 'firstName', label: 'First Name' },
  { value: 'payrollId', label: 'Payroll ID' },
  { value: 'email', label: 'Email' },
  { value: 'clientName', label: 'Client Name' },
  { value: 'project', label: 'Project' },
  { value: 'projectCode', label: 'Project Code' },
  { value: 'projectCodeAdj', label: 'Project Code Adj' },
  { value: 'classificationAdj', label: 'Classification Adj' },
  { value: 'total', label: 'Total' },
  { value: 'allocation', label: 'Allocation' },
  { value: 'milestone', label: 'Milestone' },
  { value: 'deliverable', label: 'Deliverable' },
  { value: 'taskdate', label: 'Task Date' },
  { value: 'hours', label: 'Hours' },
  { value: 'role', label: 'Role' },
  { value: 'rate', label: 'Rate' },
  { value: 'name', label: 'Name' },
  { value: 'totalCost', label: 'Total Cost' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'approvers', label: 'Approvers' },
  { value: 'approvedOn', label: 'Approved On' },
  { value: 'comment', label: 'Comment' },
  { value: 'roles', label: 'Roles' },
  { value: 'bu', label: 'BU' },
  { value: 'department', label: 'Department' },
  { value: 'classification', label: 'Classification' },
];

